module.exports = __webpack_public_path__ + "static/media/left-arrow.10ca9dbc.svg";